export default __webpack_public_path__ + "static/media/sounds/clpl_direction_Alyx.mp3";